import React from 'react'
import PageLayout from 'components/PageLayout'
import Seo from 'components/Seo'
import EcosystemHero from 'components/magic/EcosystemHero'
import Footer from 'components/magic/Footer'
import Copyright from 'components/magic/Copyright'
import EcosystemPageSections from 'components/magic/EcosystemPageSections'
import StartSelling from 'components/magic/StartSelling'
import EcosystemPlan from 'components/magic/EcosystemPlan'

import { createGlobalStyle } from 'styled-components'

const BodyStyle = createGlobalStyle`
  html,
  body {
    background-color: #000 !important;
  }
`

const MagicPage = () => (
  <PageLayout hideFooter>
    <BodyStyle />
    <Seo
      title="Flip.shop | MagicOS"
      metaImage="https://d2mdi3i6p4o1s8.cloudfront.net/magic/magic-ecosystem-preview.jpg"
    />
    <EcosystemHero />
    <EcosystemPlan />
    <EcosystemPageSections />
    <StartSelling isDark />
    <Footer />
    <Copyright />
  </PageLayout>
)

export default MagicPage
